<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div style="height: 100vh;  background: url(/assets/img/private-hotel-pool.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;" class="flex justify-content-center align-items-center">
  <div class="flex-column">
    <div class="login-card-wrapper p-shadow-2">
      <p-card>
        <div class="p-4">
          <img class="login-logo" src="assets/img/logo.png" alt="KBM Resorts Owner Login" /><br><br>
          <div>
            <h2 style="color:grey;">Admin Portal</h2>
          </div>

          @if (!showTwoFactor && !showChannelSelect) {
            <div>
              <form [formGroup]="form1" (keyup.enter)="onSubmit()">
                <div class=" p-fluid grid">
                  <div class="p-field col-12">
                    <span class="p-float-label">
                      <input formControlName="username" id="username" type="text" pInputText>
                      <label for="username">Username</label>
                      @for (validation of validationMessages.username; track validation) {
                        <span>
                          @if (form1.get('username').hasError(validation.type) && (form1.get('username').dirty || form1.get('username').touched)) {
                            <small id="username2-help" class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                    <div><br></div>
                    <span class="p-float-label">
                      <input formControlName="password" id="password" type="password" pPassword [feedback]="false">
                      <label for="password">Password</label>
                      @for (validation of validationMessages.password; track validation) {
                        <span>
                          @if (form1.get('password').hasError(validation.type) && (form1.get('password').dirty || form1.get('password').touched)) {
                            <small id="username2-help" class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                    <div>
                      @if (formErrorMessage) {
                        <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
                      }
                      <br>
                        <button pButton type="button" label="Login" (click)="onSubmit()"></button><br>
                      </div>
                      <div class="login-reset-btn">
                        <button pButton type="button" label="Reset Password" class="p-button-outlined" [routerLink]="'/password-reset-request'"></button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }

            @if (showChannelSelect) {
              <div>
                <p style="color:grey;font-size:14px;"><strong>Choose how to receive your verification code</strong></p>
                <div class="p-fluid grid">
                  <div class="p-field col-12">
                    @for (channel of twoFactorChannels; track channel.type) {
                      <button pButton type="button" (click)="onSelectChannel(channel)"
                        style="margin-bottom:10px;width:100;text-transform:none;">
                        @if (channel.type === 'email') {
                          Email to {{channel.maskedValue}}
                        } @else {
                          Text to {{channel.maskedValue}}
                        }
                      </button>
                    }
                    @if (formErrorMessage) {
                      <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
                    }
                    <div class="login-reset-btn">
                      <button pButton type="button" label="Back to Login" class="p-button-outlined" (click)="backToLogin()"></button>
                    </div>
                  </div>
                </div>
              </div>
            }

            @if (showTwoFactor) {
              <div>
                <p style="color:grey;font-size:14px;"><strong>A verification code has been sent to {{maskedDestination || maskedEmail}}</strong></p>
                <div class="p-fluid grid">
                  <div class="p-field col-12">
                    <span class="p-float-label">
                      <input [(ngModel)]="twoFactorCode" id="twoFactorCode" type="text"
                        pInputText maxlength="6" (keyup.enter)="onSubmit2FA()"
                        style="font-size:20px;letter-spacing:8px;text-align:center;">
                        <label for="twoFactorCode">Verification Code</label>
                      </span>
                      <div>
                        @if (formErrorMessage) {
                          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
                        }
                        <br>
                          <button pButton type="button" label="Verify" (click)="onSubmit2FA()"></button>
                        </div>
                        <div class="login-reset-btn">
                          @if (twoFactorChannels.length > 1) {
                            <button pButton type="button" label="Choose Different Method" class="p-button-outlined" (click)="backToChannelSelect()" style="margin-bottom:8px;"></button>
                          }
                          <button pButton type="button" label="Back to Login" class="p-button-outlined" (click)="backToLogin()"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                }

              </div>
            </p-card>
          </div>
        </div>
      </div>
